import { useActiveOrganization } from "./useActiveOrganization";
import { useActiveWorkspace } from "./useActiveWorkspace";
import { useUser } from "./useUser";

export function useOnboardingStatus() {
    const activeWorkspace = useActiveWorkspace();
    const activeOrganization = useActiveOrganization();
    const user = useUser();

    if (!user?.onboardingComplete) {
        return false;
    }

    if (activeOrganization && !activeOrganization.onboardingCompletedAt) {
        return false;
    }

    return !(activeWorkspace && !activeWorkspace.onboardingCompletedAt);
}
